export const formatTime = (d: string) => {
  const newDate = new Date(d);
  return newDate.toLocaleTimeString("es-CL", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (d: string) => {
  const newDate = new Date(d);

  return newDate
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replaceAll("/", "-");
};
